import {Component, Injector} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {
    AbstractSingleSelectEditControlComponent
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-single-select-edit-control.component";
import {SurchargeSearchModel} from "../surcharge-search.model";
import {SurchargeSearchPageComponent} from "../surcharge-search-page/surcharge-search-page.component";
import {SurchargeEditPageComponent} from "../surcharge-edit-page/surcharge-edit-page.component";
import {
    registerSelectEditControl
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-select-edit-control.component";

@Component({
    selector: "wbo-surcharge-single-select-edit-control",
    templateUrl: "../../../framework/entity/edit/edit-controls/select-edit-controls/single-select-edit-control.component.html",
    providers: [
        registerSelectEditControl(SurchargeSingleSelectEditControlComponent),
        provideSearchModel(SurchargeSearchModel)
    ]
})
export class SurchargeSingleSelectEditControlComponent extends AbstractSingleSelectEditControlComponent<SurchargeSearchModel> {
    constructor(model: SurchargeSearchModel, injector: Injector) {
        super(model, injector, "surchargeId", "name");
        this.extendedSearchComponent = SurchargeSearchPageComponent;
        this.extendedEditComponent = SurchargeEditPageComponent;
    }
}
